/**
 * Height of the white page header; the docked Reva column starts below it.
 * Kept dependency-free so the marketing site's /browse can import it without
 * pulling in the app shell.
 */
export const APP_HEADER_HEIGHT = 64;
